module.exports = __webpack_public_path__ + "img/notificacao.ce4025f2.svg";